import { Trans, useTranslation } from 'react-i18next'
import { Box, Button, Stack, TextField } from '@mui/material'
import { useState } from 'react'
import { Device, DeviceHwID, DeviceSpec } from '../../types/models'
import { DeviceSpecSelector } from './DeviceSpecSelector'

export interface DeviceFormProps {
  new: boolean
  onSubmit: (device: Partial<Device>) => void
}

export function DeviceForm(props: DeviceFormProps): React.ReactElement {

  const [spec, setSpec] = useState<DeviceSpec | null>(null)
  const [deviceId, setDeviceId] = useState<DeviceHwID>('' as DeviceHwID)
  const [comments, setComments] = useState('')
  const [name, setName] = useState('')

  const { t } = useTranslation()

  return (
    <Box sx={{ pb: 4, mb: 4 }}>
      <Stack spacing={4}>
        <DeviceSpecSelector
          spec={spec}
          onChange={(value) => setSpec(value)}
        />

        <TextField
          id="hw-id"
          data-cy="text-Device ID"
          label={t('Device ID')}
          disabled={!spec}
          value={deviceId}
          onChange={(e) => setDeviceId(e.target.value.toUpperCase() as DeviceHwID)}
          fullWidth
          autoComplete='off'
        />

        <TextField
          id="name"
          data-cy="text-Device name"
          label={t('Name')}
          disabled={!spec}
          value={name}
          onChange={(e) => setName(e.target.value)}
          fullWidth
          required
          minRows={3}
        />

        <TextField
          id="comments"
          data-cy="text-Device comments"
          label={t('Comments')}
          disabled={!spec}
          value={comments}
          onChange={(e) => setComments(e.target.value)}
          fullWidth
          multiline
          minRows={3}
        />

        <Button
          data-cy="button-Create Device"
          variant="outlined"
          color="secondary"
          fullWidth
          disabled={!spec || !deviceId}
          onClick={() => spec && props.onSubmit({
            hw_id: deviceId,
            device_spec_id: spec.id,
            name,
            comments
          })}
          size="large"
        >
          <Trans>Create Device</Trans>
        </Button>

      </Stack>
    </Box>
  )
}
